import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export function useMetaPixel(pixelId: string) {
  useEffect(() => {
    // Prevent double-initialization
    if (window.fbq) return

    const f: any = function (...args: any[]) {
      f.callMethod ? f.callMethod.apply(f, args) : f.queue.push(args)
    }
    f.push = f
    f.loaded = true
    f.version = '2.0'
    f.queue = []

    window.fbq = f
    window._fbq = f

    // Load the Facebook Pixel script
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)

    // Initialize pixel and fire PageView
    window.fbq('init', pixelId)
    window.fbq('track', 'PageView')

    // Add noscript fallback
    const noscript = document.createElement('noscript')
    const img = document.createElement('img')
    img.height = 1
    img.width = 1
    img.style.display = 'none'
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`
    noscript.appendChild(img)
    document.body.appendChild(noscript)
  }, [pixelId])
}
